import {
  Component,
  HostBinding,
  ViewEncapsulation
} from '@angular/core';
import { Observable } from 'rxjs';
import { PaginationModel } from '@spartacus/core';
import { TableStructure } from '@spartacus/storefront';
import {
  ItemService,
  ListComponent,
  ListService
} from '@spartacus/organization/administration/components';
import { UigListService } from '../../services/uig-list.service';
import { UigOrganizationTableType } from '../../uig-organization.model';

@Component({
    selector: 'app-uig-list',
    templateUrl: './uig-list.component.html',
    styleUrls: ['./uig-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigListComponent<T = any, P = PaginationModel> extends ListComponent<T, P>{

  readonly uigStructure$: Observable<TableStructure> = this.uigService.getStructure();

  constructor(
    protected service: ListService<T, P>,
    protected organizationItemService: ItemService<T>,
    protected uigService: UigListService<T, P>
  ) {
    super(service, organizationItemService);
  }

  @HostBinding('class')
  uigViewType: UigOrganizationTableType = UigOrganizationTableType.BRANCHES;

  ngOnInit(): void {

  }

}
